import React from 'react';

export const SignOutIcon = ({ width = 20, height = 20, color = '#454550' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0833 14.1667V5.83333C17.0833 5.375 17.4583 5 17.9167 5C18.375 5 18.75 5.375 18.75 5.83333V14.1667C18.75 14.625 18.375 15 17.9167 15C17.4583 15 17.0833 14.625 17.0833 14.1667ZM13.0583 9.1667L10.6583 6.7667C10.3333 6.4417 10.3417 5.90836 10.6583 5.58336C10.814 5.42732 11.0254 5.33963 11.2458 5.33963C11.4663 5.33963 11.6776 5.42732 11.8333 5.58336L15.6583 9.40836C15.9833 9.73336 15.9833 10.2584 15.6583 10.5834L11.8333 14.4084C11.5083 14.7334 10.9833 14.7334 10.6583 14.4084C10.3333 14.0834 10.3333 13.5584 10.6583 13.2334L13.0583 10.8334H2.08333C1.625 10.8334 1.25 10.4584 1.25 10C1.25 9.5417 1.625 9.1667 2.08333 9.1667H13.0583Z"
      fill={color}
    />
  </svg>
);
